import { useTranslation } from 'react-i18next';
import { KoobAlert } from '@koob/ui';

const CancelConditionsOverlapAlert = () => {
  const { t } = useTranslation();

  return (
    <KoobAlert variant="warning" icon="fa-triangle-exclamation">
      {t('errors:cancelConditionsOverlapAlert')}
    </KoobAlert>
  );
};

export default CancelConditionsOverlapAlert;
